const PaddleEndpoints = {
  checkout: {
    completed: {
      method: 'POST',
      url: () => '/paddle/checkout/completed',
    }
  },
} as const;

// Create type from the object
type PaddleEndpoints = typeof PaddleEndpoints;

export type { PaddleEndpoints };
export default PaddleEndpoints;
